// extracted by mini-css-extract-plugin
module.exports = {"reviewStar":"Reviews_reviewStar__7dk83","reviewStarMobile":"Reviews_reviewStarMobile__ichkV","textColor":"Reviews_textColor__2oWP2"};